<template>
  <div>
    <v-row
      align="center"
      justify="center"
      :style="{ height: `${$vuetify.breakpoint.height - 24}px` }"
    >
      <v-col cols="auto" v-if="!deny">
        <v-progress-circular indeterminate color="cyan"></v-progress-circular>
      </v-col>
      <v-col cols="auto" v-else class="d-flex flex-column">
        <v-icon x-large color="red">mdi-cancel</v-icon>
        <span>你沒有權限執行該項操作</span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["clinic"],
  data: () => ({
    params: {},
    profile: {},
    user: {},
    deny: false
  }),
  methods: {
    async getProfile() {
      if (process.env.NODE_ENV === "development") {
        this.profile.userId = "Udef0da4cc49048f0ae7adf34dad40ec6";
      } else {
        this.profile = await this.$liff.getProfile();
        //this.profile.userId = "Udef0da4cc49048f0ae7adf34dad40ec6";
      }
    },
    async getUser() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.clinic}/users/bot/${this.profile.userId}`
      );
      this.user = response.data;
    },
    async sendAction() {
      // send action to remote
      await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/liff/bot/${this.profile.userId}`,
        {
          action: this.params.action,
          selectId: this.params.selectId
        }
      );
    },
    closeSelf(redirect = true) {
      if (this.$liff.isInClient()) {
        // in line app
        if (redirect) {
          // this.$liff.openWindow({
          //   url: `line://oaMessage/${this.params.botId}/`
          // });
          window.location.href = `line://oaMessage/${this.params.botId}/`;
        } else {
          this.$liff.closeWindow();
        }
      } else {
        //in external web
        window.location.href = `line://oaMessage/${this.params.botId}/`;
      }
    }
  },
  async mounted() {
    //liff init
    try {
      await this.$liff.init({ liffId: this.params.liffId });
      if (process.env.NODE_ENV === "development") {
        await this.getProfile();
      } else if (this.$liff.isInClient() || this.$liff.isLoggedIn()) {
        //in line app or user already login
        await this.getProfile();
      } else {
        //in external web and not login
        this.$liff.login();
      }

      await this.getUser();

      if (
        this.user === null ||
        this.user.clinic !== this.clinic ||
        (this.user.permission !== "role_admin" &&
          this.user.permission !== "role_staff")
      ) {
        this.deny = true;
        let thisVm = this;
        setTimeout(() => thisVm.closeSelf(false), 3000);
      } else {
        await this.sendAction();
        this.closeSelf();
      }
    } catch (e) {
      alert(e);
    }
  },
  created() {
    //parse url parameter
    const url = new URL(window.location.href);

    for (let [key, value] of url.searchParams.entries()) {
      this.params[key] = value;
    }

    // console.log("params:" + JSON.stringify(thisVm.params));
    if (!this.params.liffId) {
      alert("liffId undefined");
    }
    if (!this.params.botId) {
      alert("botId undefined");
    }
    if (!this.params.action) {
      alert("action undefined");
    }
    if (!this.params.selectId) {
      alert("selectId undefined");
    }
  }
};
</script>
